import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { SnackbarNotification } from "@components/molecules/snackbar-notification/snackbar-notification";

export const SnackbarNotifications = () => {
  const snackbarNotification = useSelector(
    (state: RootState) => state.yourSlice.snackbarNotification,
  );

  return (
    <>{snackbarNotification.state === "open" && <SnackbarNotification />}</>
  );
};
